import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><rect width=\"72\" height=\"72\" x=\"-1\" y=\"-1\" fill=\"#212B32\" rx=\"24\"></rect><rect width=\"72\" height=\"72\" x=\"-1\" y=\"-1\" fill=\"#9F7BD6\" rx=\"24\"></rect><path fill=\"#4EBC74\" d=\"M60.5 20.5c-8 4.5-5.5 21-25 20-15.231-.78-18.356 15.534-18.03 24.372L19 70.5h59L79.5 24c-3.667-2.667-12.6-7.1-19-3.5Z\"></path><path fill=\"#57ABC8\" d=\"M9 48c8-4.5 5.5-21 25-20 15.231.78 18.356-15.534 18.03-24.372L50.5-2h-59L-10 44.5c3.667 2.667 12.6 7.1 19 3.5Z\"></path></g><defs><clipPath id=\"a\"><rect width=\"61\" height=\"60\" fill=\"#fff\" rx=\"24\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }